import React from "react";
import { QrCode, Wallet } from "lucide-react";
import "./Payment.css";
import RazorpayQR from "../../assets/QrCode.jpeg";



const Payment = () => {
  return (
    <div className="payment-page">
      <h2 className="payment-title">Payment & Payout</h2>

      <div className="payment-card">
        <div className="payment-header">
          <Wallet size={24} />
          <h3>Your Payment QR Code</h3>
        </div>

        <p className="payment-desc">
          Scan this QR code to send payments directly to your linked Razorpay account.
        </p>

        <div className="qr-section">
          <a href={RazorpayQR} target="_blank" rel="noopener noreferrer">
            <img src={RazorpayQR} alt="Razorpay QR" className="qr-image" />
          </a>
        </div>

        <p className="upi-id">Linked UPI ID: <strong>rismicmartpriva145433.rzp@rxairtel</strong></p>
      </div>
    </div>
  );
};

export default Payment;
